import { RawJsonKinds } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';

const getJsonKindText = (kind: RawJsonKinds) => {
  const { t } = useTranslation('entity-details', {
    keyPrefix: 'fieldset.documents.details.rawJsonData',
  });

  if (kind === RawJsonKinds.CurpValidationResponse) {
    return t($ => $.curpValidationResponse);
  }
  if (kind === RawJsonKinds.SambaActivityHistoryResponse) {
    return t($ => $.sambaActivityHistoryResponse);
  }
};

export default getJsonKindText;
